<template>
  <div v-if="$ability.can('read', 'Farm')">
    <div v-if="loadingList">
      <AppSkeletonTable></AppSkeletonTable>
    </div>
    <div v-else>
      <DataTable
        :value="results"
        responsiveLayout="stack"
        :scrollable="$isLargeScreen.value"
      >
        <Column header="Nome" field="name" style="min-width: 120px"> </Column>
        <Column header="Status" field="status" style="min-width: 120px">
          <template #body="{ data: { status } }">
            <AppStatusTag :status="status"></AppStatusTag>
          </template>
        </Column>
        <Column
          header="Quantidade de Lotes/Piquetes"
          field="stats.lotCount"
          style="min-width: 140px"
          :sortable="true"
        ></Column>
        <Column
          header="Total de Bovinos"
          field="stats.bovineCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Touros"
          field="stats.bullCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Bois"
          field="stats.oxCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Vacas"
          field="stats.cowCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Bezerros"
          field="stats.calfCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Quantidade de Bezerras"
          field="stats.heiferCount"
          style="min-width: 120px"
          :sortable="true"
        ></Column>
        <Column
          header="Ações"
          style="min-width: 100px"
          alignFrozen="right"
          :frozen="true"
        >
          <template #body="{ data: { id } }">
            <AppRouterLink
              :to="{ name: 'farm.edit', params: { id } }"
              :permission="{ action: 'write', subject: 'Farm' }"
            >
              <Button
                :disabled="!$ability.can('write', 'Farm')"
                type="button"
                icon="pi pi-pencil"
                class="p-button-text p-button-secondary p-mr-1"
              ></Button>
            </AppRouterLink>
            <Button
              type="button"
              icon="pi pi-trash"
              class="p-button-text p-button-secondary"
              :disabled="!$ability.can('delete', 'Farm')"
              @click="showDeleteConfirm(results, id, 'name')"
            ></Button>
          </template>
        </Column>
      </DataTable>
      <Paginator
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        @page="changeListPage({ page: $event.page + 1 })"
      ></Paginator>
      <router-link
        :to="{ name: 'farm.create' }"
        style="text-decoration: none"
        v-if="$ability.can('write', 'Farm')"
      >
        <AppFloatButton icon="pi pi-plus" />
      </router-link>
      <AppModalDelete
        type="Fazenda"
        :visible="deleteConfirm.visible"
        :item="deleteConfirm.item"
        @confirm="onDelete()"
        @cancel="hideDeleteConfirm()"
      ></AppModalDelete>
    </div>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import useDeleteConfirm from '../../lib/useDeleteConfirm';
import useApiList from '../../lib/useApiList';
import { FarmApi } from '../../services/api';

export default {
  name: 'FarmList',
  setup() {
    return {
      ...useApiList(FarmApi, { include: '[stats]' }),
      ...useDeleteConfirm(),
    };
  },
  async created() {
    await this.fetchList();
  },
  methods: {
    async onDelete() {
      try {
        await this.deleteListItem(this.deleteConfirm.id);
        this.hideDeleteConfirm();
      } catch (error) {
        console.error(error);
        if (error.code === 'ConflictError') {
          this.$toast.add({
            severity: 'error',
            summary: 'Desculpe! Não é possível excluir.',
            detail: 'Esta fazenda possui bovinos associados.',
            life: 3000,
          });
          this.hideDeleteConfirm();
        }
      }
    },
  },
};
</script>

<style>
</style>